import { IItemCache } from '../IItemCacheObserver';
import { preferredKeyFacetFacet } from '../../facets/OperationFacets';

export function getPreferredItemKey(itemCache: IItemCache, props: {
  itemKey: string | undefined;
}): string | undefined {
  const {
    itemKey
  } = props;

  const preferredKeyFacet = itemCache.demandItemFacet(preferredKeyFacetFacet, itemKey);

  if (!preferredKeyFacet) {
    return itemKey;
  }

  const preferredItem = itemCache.demandItemFacet(preferredKeyFacet, itemKey);

  const preferredItemKey = preferredItem && preferredKeyFacet.serialize(preferredItem) || itemKey;

  return preferredItemKey;
}
